import { MetricKpiCard } from "@/features/dashboard/shell";
import { OverviewSection } from "@/features/dashboard/hub/OverviewSection";

import {
  MOCK_LAB_PENDING_MAPPING,
  MOCK_LAB_SPARKLINE,
  MOCK_LAB_STUDIES_TODAY,
} from "./mock-data";

/**
 * Overview mock de laboratorio (hoy).
 */
export function LaboratoryOverview(): React.JSX.Element {
  return (
    <OverviewSection
      title="Laboratorio"
      description="Estudios de hoy · sin tipificar por modalidad"
      isMock
    >
      <div className="grid grid-cols-2 gap-3">
        <MetricKpiCard
          label="Estudios hoy"
          value={MOCK_LAB_STUDIES_TODAY}
          hint="Órdenes de laboratorio del día (mock)"
          sparkline={MOCK_LAB_SPARKLINE}
        />
        <MetricKpiCard
          label="Pendientes de mapeo"
          value={MOCK_LAB_PENDING_MAPPING}
          hint="Pruebas que un bioanalista debe clasificar (mock)"
          accentClassName={
            MOCK_LAB_PENDING_MAPPING > 0
              ? "text-amber-600 dark:text-amber-400"
              : undefined
          }
        />
      </div>
    </OverviewSection>
  );
}
